
<!-- start -->
<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-title>Add Sound And Text</ion-title>
    <ion-buttons slot="end">
      <ion-title style="cursor: pointer;" size="large" (click)="goToMenu()">Menu</ion-title>
      <ion-title style="cursor: pointer;" size="large" (click)="confirmLogout()">Logout</ion-title>
  </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ng-container>
    <form [formGroup]="addSoundTextForm" (ngSubmit)="onSubmit()" class="addtext-form">
      <ion-list>
      <ion-item class="form-item">
        <ion-input 
          formControlName="message"
          type="text" 
          required 
          Placeholder = "Enter your text here ..."
          [(ngModel)]="formData.message" 
          name="message">
          
        </ion-input>
  
      </ion-item>  

      <ion-item class="form-item">
        <input 
          type="file" 
          accept="audio/*" 
          (change)="onFileSelected($event)" />
   
      </ion-item>
      
      <ion-item class="form-item">
        <ion-label position="floating">Language:</ion-label>
        <ion-select name="lang" formControlName="lang" required>
          <ion-select-option value="nl" selected>Dutch</ion-select-option>
          <ion-select-option value="english">English</ion-select-option>
        </ion-select>
      </ion-item>

      <ion-item class="form-item">
        <ion-label position="floating">Type:</ion-label>
        <ion-select name="lang" formControlName="type" required>
          <ion-select-option value="prioritize_text">PrioritizeText</ion-select-option>
          <ion-select-option value="mozilla_text">MozillaText</ion-select-option>
          <ion-select-option value="text" selected>Text</ion-select-option>
          <ion-select-option value="surveyforms" selected>SurveyForms</ion-select-option>
          <ion-select-option value="character">Character</ion-select-option>
          <ion-select-option value="number">Number</ion-select-option>
          <ion-select-option value="outbound">Outbound</ion-select-option>
        </ion-select>
      </ion-item>

      <ion-col class="toggle-container" >
        <ion-item lines="none"  class="toggle-item" style="width: 40%;">
          <ion-label class="toggle-label">Is For Interpretation Only</ion-label>
          <ion-toggle    (ionChange)="onToggleChange($event)"></ion-toggle>
        </ion-item>
      </ion-col>

      
  

      <ion-button type="submit" expand="block" class="submit-button" [disabled]="!addSoundTextForm.valid">Save</ion-button>
    </ion-list>
    </form>
  </ng-container>
</ion-content>
